import { useState } from "react";

import { ApiKeyCreateResponse } from "@nens/rana/api-v1";
import { useSessionStorage } from "@nens/react/hooks";

import { getId } from "../../../_internal";
import { usePublicationStore } from "../../../store";

export const useFilesAsUrlsExplanation = () => {
  const publicationId = usePublicationStore(getId);
  const [createdShareKeyStorage, setCreatedShareKeyStorage] = useSessionStorage<{
    [publicationId: string]: string;
  }>("createdShareKeyStorage", {});
  const setCreatedShareKey = (shareKey: ApiKeyCreateResponse) => {
    setCreatedShareKeyStorage((prev) => ({
      ...prev,
      [publicationId]: shareKey.value,
    }));
  };
  const createdShareKey = createdShareKeyStorage[publicationId];

  const [showCreateForm, setShowCreateForm] = useState(false);

  return {
    createdShareKey,
    setCreatedShareKey,
    showCreateForm,
    setShowCreateForm,
  };
};
